import { createContext } from "react";

import type { LoggerContract } from "@core/foundation/logger";

export const LoggerContext = createContext<LoggerContract | null>(null);
